import {useState} from 'react';
import {Typography} from '../../atoms/Typography';

export const FooterAccordion = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <ul className="footer__accordion">
      <li className="accordion-item">
        <button
          type="button"
          data-qa-id="footer_aboutus"
          className="unstyled-button accordion-header label2"
          onClick={() => toggleAccordion(0)}
        >
          <Typography as="span" variant="label2" size="large">
            About Us
          </Typography>
          {/** biome-ignore lint/a11y/noSvgWithoutTitle: Fix me! */}
          <svg
            className="accordion-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99998 7.36663L4.69998 10.6666L3.75731 9.72396L7.99998 5.48129L12.2426 9.72396L11.3 10.6666L7.99998 7.36663Z"
              fill="#101B21"
            />
          </svg>
        </button>
        {activeAccordion === 0 && (
          <div className="accordion-content list2 medium">
            <a href="/pages/about-us" data-qa-id="footer_story">
              Our story
            </a>
            <a href="/blog/" data-qa-id="footer_blog">
              Blog
            </a>
            <a href="/pages/press/" data-qa-id="footer_press">
              Press
            </a>
            <a href="/pages/careers/" data-qa-id="footer_careers">
              Careers
            </a>
            <a href="/pages/donation/" data-qa-id="footer_giving">
              Giving back
            </a>
          </div>
        )}
      </li>

      <li className="accordion-item">
        <button
          type="button"
          data-qa-id="footer_help"
          className="unstyled-button accordion-header label2"
          onClick={() => toggleAccordion(1)}
        >
          <Typography as="span" variant="label2" size="large">
            Get Help
          </Typography>
          {/** biome-ignore lint/a11y/noSvgWithoutTitle: Fix me! */}
          <svg
            className="accordion-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99998 7.36663L4.69998 10.6666L3.75731 9.72396L7.99998 5.48129L12.2426 9.72396L11.3 10.6666L7.99998 7.36663Z"
              fill="#101B21"
            />
          </svg>
        </button>
        {activeAccordion === 1 && (
          <div className="accordion-content list2 medium">
            <a href="https://support.evite.com/" data-qa-id="footer_faqs">
              FAQs
            </a>
            <a href="https://www.evite.com/pages/support-ticket/" data-qa-id="footer_contact">
              Contact us
            </a>
            <a
              href="https://support.evite.com/support/solutions/articles/72000576133-invitation-pricing"
              data-qa-id="footer_pricing"
            >
              Pricing
            </a>
            <a
              href="https://support.evite.com/support/solutions/articles/72000576127-free-vs-premium-invitations"
              data-qa-id="footer_prem_v_free"
            >
              Premium vs. Free
            </a>
          </div>
        )}
      </li>

      <li className="accordion-item">
        <button
          type="button"
          data-qa-id="footer_explore"
          className="unstyled-button accordion-header label2"
          onClick={() => toggleAccordion(2)}
        >
          <Typography as="span" variant="label2" size="large">
            Explore
          </Typography>
          {/** biome-ignore lint/a11y/noSvgWithoutTitle: Fix me! */}
          <svg
            className="accordion-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99998 7.36663L4.69998 10.6666L3.75731 9.72396L7.99998 5.48129L12.2426 9.72396L11.3 10.6666L7.99998 7.36663Z"
              fill="#101B21"
            />
          </svg>
        </button>
        {activeAccordion === 2 && (
          <div className="accordion-content list2 medium">
            <a href="/invites/" data-qa-id="footer_invitations">
              Invitations
            </a>
            <a href="/signup-sheets/" data-qa-id="footer_sus">
              SignUp Sheets
            </a>
            <a href="/cards/featured" data-qa-id="footer_ecards">
              Greeting Cards
            </a>
            <a href="/egift-cards/" data-qa-id="footer_egift_cards">
              eGift Cards
            </a>
            <a href="/pro" data-qa-id="footer_evite_pro">
              Evite Pro
            </a>
            <a href="/content/site_map" data-qa-id="footer_site_map">
              Site map
            </a>
          </div>
        )}
      </li>

      <li className="accordion-item">
        <button
          type="button"
          data-qa-id="footer_myevite"
          className="unstyled-button accordion-header label2"
          onClick={() => toggleAccordion(3)}
        >
          <Typography as="span" variant="label2" size="large">
            My Evite
          </Typography>
          {/** biome-ignore lint/a11y/noSvgWithoutTitle: Fix me! */}
          <svg
            className="accordion-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.99998 7.36663L4.69998 10.6666L3.75731 9.72396L7.99998 5.48129L12.2426 9.72396L11.3 10.6666L7.99998 7.36663Z"
              fill="#101B21"
            />
          </svg>
        </button>
        {activeAccordion === 3 && (
          <div className="accordion-content list2 medium">
            <a href="/settings/account" data-qa-id="footer_account">
              My Account
            </a>
            <a href="/my-events/" data-qa-id="footer_myevents">
              My Invitations
            </a>
            <a
              href="/my-events/?type=signup-sheets&offset=0&status=all"
              data-qa-id="footer_mysheets"
            >
              My SignUp Sheets
            </a>
            <a href="/my-events/?type=card&offset=0&status=all" data-qa-id="footer_myecards">
              My eCards
            </a>
            <a href="/login" data-qa-id="footer_signin">
              Sign In
            </a>
          </div>
        )}
      </li>
    </ul>
  );
};
